import React from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {Spinner} from "../../Spinner";
import {DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET} from "../../../daily_limits";
import AdAccountReadOnlyInput from "../../elements/AdAccountReadOnlyInput";
import {ClientAdAccountFormBaseClass} from "./ClientAdAccountFormBase";
import { withTranslation } from 'react-i18next';


class EditClientAdAccountFormComponent extends ClientAdAccountFormBaseClass {
    constructor(props) {
        super(props);

        // Si no hay daily_limit_currency, pone ARS como default
        this.state = {
            ...this.state,
            updateClientAdAccount: false,
            daily_limit_type: this.props.clientAdAccount.daily_limit_type ? this.props.clientAdAccount.daily_limit_type : DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET,
            daily_limit_currency: this.props.clientAdAccount.daily_limit_currency ? this.props.clientAdAccount.daily_limit_currency : "ARS",
            daily_limit_value: this.props.clientAdAccount.daily_limit_value,
            dailyLimitEnabled: this.isDailyLimitEnabledOnClientAdAccount(this.props.clientAdAccount)
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.footerButton = this.footerButton.bind(this);
    }

    isDailyLimitEnabledOnClientAdAccount(clientAdAccount) {
        return clientAdAccount.daily_limit_currency !== undefined && clientAdAccount.daily_limit_currency !== null && clientAdAccount.daily_limit_value !== undefined && clientAdAccount.daily_limit_value !== null;
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({
            updateClientAdAccount: true
        });

        new APIClient(this.submitUrl()).call('POST', this._getDataToPost()).then((data) => {
            this.setState({
                updateClientAdAccount: false
            });

            if (data.status === 'ERROR') {
                alert(data.error_message);
            } else if (data.status === 'OK') {
                this.props.afterSuccessfulEdited(data.data.agency_client_ad_account_id)
            }
        });
    }

    footerButton() {
        if (this.state.updateClientAdAccount) {
            return <Spinner color="positive small"/>
        } else {
            const { t } = this.props;
            return <input type="submit" value={t('client.save_button')} className="btn -submit"/>
        }
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <div className="form-group">
                            {this.renderClientAndAccountRow()}
                            {this.renderRadioButtonOptions()}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.footerButton()}
                </ModalFooter>
            </form>
        )
    }

    renderClientAndAccountRow() {
        const { t } = this.props;
        return <div className="row">
            <div className="col-md-6">
                <label>{t('edit_client_ad_account_form.client')}</label>
                <input name="client" type="text" value={this.props.clientName} readOnly="readonly"
                       className="form-control pl-3"/>
            </div>
            <div className="col-md-6">
                <label>{t('edit_client_ad_account_form.account')}</label>
                <AdAccountReadOnlyInput channel={this.props.clientAdAccount.channel}
                                        adAccountName={this.props.clientAdAccount.name}
                                        adAccountId={this.props.clientAdAccount.account_id}/>
            </div>
        </div>;
    }



    submitUrl() {
        return API_URL + 'client/ad_account/' + this.props.clientAdAccount.id + '/edit';
    }
}

export const EditClientAdAccountForm = withTranslation()(EditClientAdAccountFormComponent);
